<div class="container-fluid pl-0">
    <div class="container-inner">
        <div class="header-container">
            <h2>Clients</h2>
            <div class="button-container">
                <!-- <button mat-raised-button color="primary  ">Add Client</button> -->
            </div>
        </div>
        <div class="leads-table mb-3">
            <table mat-table [dataSource]="dataSource" matSort class="mat-table">

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Name</th>
                    <td mat-cell *matCellDef="let element">{{element.name}}</td>
                </ng-container>

                <ng-container matColumnDef="password">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Password</th>
                    <td mat-cell *matCellDef="let element">{{element.password}}</td>
                </ng-container>

                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email ID</th>
                    <td mat-cell *matCellDef="let element">{{element.email}}</td>
                </ng-container>

                <ng-container matColumnDef="alternate_email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Alternate Email ID</th>
                    <td mat-cell *matCellDef="let element">{{element.alternate_email}}</td>
                </ng-container>

                <ng-container matColumnDef="contact_number">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
                    <td mat-cell *matCellDef="let element">{{element.contact_number}}</td>
                </ng-container>

                <ng-container matColumnDef="alternate_number">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Alternate Number</th>
                    <td mat-cell *matCellDef="let element">{{element.alternate_number}}</td>
                </ng-container>

                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                    <td mat-cell *matCellDef="let element">{{element.address}}</td>
                </ng-container>

                <!-- Action Column -->
                <!-- <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element"><a href="#" class="action-link">Details</a></td>
            </ng-container> -->

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>